(() => {
  const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const announceCart = async (source, sourceId) => {
    try {
      const response = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId, data: { source, itemCount: cart.item_count } },
        })
      );
    } catch (error) {
      return;
    }
  };

  if (!customElements.get('origen-collection')) {
    class OrigenCollection extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('[data-filter-form]');
        this.toggle = this.querySelector('[data-filter-toggle]');

        if (this.toggle) {
          this.toggle.hidden = false;
          const mobile = window.matchMedia('(max-width: 899px)').matches;
          let hidden = mobile;
          try {
            const stored = sessionStorage.getItem('origen-filters');
            if (!mobile && stored) hidden = stored === 'hidden';
          } catch (error) {}
          this.setFilters(hidden);
          this.toggle.addEventListener('click', () => {
            const nextHidden = this.dataset.filters !== 'hidden';
            this.setFilters(nextHidden);
            try {
              if (!window.matchMedia('(max-width: 899px)').matches) {
                sessionStorage.setItem('origen-filters', nextHidden ? 'hidden' : 'shown');
              }
            } catch (error) {}
          });
        }

        if (!this.form) return;
        this.querySelectorAll('[data-auto-submit]').forEach((control) => {
          control.addEventListener('change', () => this.submit());
        });
        const priceApply = this.form.querySelector('[data-price-apply]');
        this.form.querySelectorAll('.origen-price-range input').forEach((input) => {
          input.addEventListener('input', () => {
            if (priceApply) priceApply.hidden = false;
          });
        });
        this.form.addEventListener('submit', () => {
          this.form.querySelectorAll('.origen-price-range input').forEach((input) => {
            if (input.value === '') input.disabled = true;
          });
        });
      }

      setFilters(hidden) {
        this.dataset.filters = hidden ? 'hidden' : 'shown';
        this.toggle.setAttribute('aria-expanded', String(!hidden));
        const label = this.toggle.querySelector('[data-filter-toggle-label]');
        label.textContent = hidden ? this.toggle.dataset.labelShow : this.toggle.dataset.labelHide;
      }

      submit() {
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      }
    }
    customElements.define('origen-collection', OrigenCollection);
  }

  if (!customElements.get('origen-cart')) {
    class OrigenCart extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.noteTimer = null;
        this.quantityTimers = new Map();

        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-cart-step]');
          if (step) {
            const input = this.querySelector(`[data-cart-quantity][data-line="${step.dataset.line}"]`);
            const max = input.max ? Number(input.max) : Infinity;
            const next = Math.min(max, Math.max(0, Number(input.value || 0) + Number(step.dataset.cartStep)));
            input.value = next;
            this.queueQuantity(step.dataset.line, next);
            return;
          }
          const remove = event.target.closest('[data-cart-remove]');
          if (remove) {
            event.preventDefault();
            this.change(remove.dataset.line, 0);
            return;
          }
          if (event.target.closest('[data-discount-apply]')) {
            this.applyDiscount();
            return;
          }
          const removeCode = event.target.closest('[data-discount-remove]');
          if (removeCode) this.updateDiscounts(this.currentCodes().filter((code) => code !== removeCode.dataset.discountRemove));
        });

        this.addEventListener('change', (event) => {
          const input = event.target.closest('[data-cart-quantity]');
          if (input) this.queueQuantity(input.dataset.line, Math.max(0, Math.round(Number(input.value)) || 0));
        });

        this.addEventListener('input', (event) => {
          if (!event.target.matches('[data-cart-note]')) return;
          clearTimeout(this.noteTimer);
          const note = event.target.value;
          this.noteTimer = setTimeout(async () => {
            if (await this.post(this.dataset.updateUrl, { note }, false)) this.showSaved();
          }, 600);
        });

        this.addEventListener('change', async (event) => {
          const field = event.target.closest('[data-cart-attribute]');
          if (!field) return;
          const attributes = { [field.dataset.cartAttribute]: field.value };
          if (await this.post(this.dataset.updateUrl, { attributes }, false)) this.showSaved();
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && event.target.matches('[data-discount-input]')) {
            event.preventDefault();
            this.applyDiscount();
          }
        });
      }

      get status() {
        return this.querySelector('[data-cart-status]');
      }

      currentCodes() {
        return Array.from(this.querySelectorAll('[data-discount-code]')).map((item) => item.dataset.discountCode);
      }

      queueQuantity(line, quantity) {
        clearTimeout(this.quantityTimers.get(line));
        this.quantityTimers.set(line, setTimeout(() => this.change(line, quantity), 350));
      }

      change(line, quantity) {
        return this.post(this.dataset.changeUrl, { line: Number(line), quantity });
      }

      applyDiscount() {
        const input = this.querySelector('[data-discount-input]');
        const code = input.value.trim();
        if (!code) {
          input.focus();
          return;
        }
        const codes = this.currentCodes();
        if (!codes.includes(code)) codes.push(code);
        this.updateDiscounts(codes, code);
      }

      async updateDiscounts(codes, newCode) {
        const cart = await this.post(this.dataset.updateUrl, { discount: codes.join(',') });
        if (!cart || !newCode) return;
        const applied = (cart.discount_codes || []).find((item) => item.code.toLowerCase() === newCode.toLowerCase());
        if (!applied || !applied.applicable) this.setStatus(this.dataset.messageDiscount);
      }

      showSaved() {
        const saved = this.querySelector('[data-cart-saved]');
        if (!saved) return;
        saved.textContent = 'Guardado en tu pedido.';
        clearTimeout(this.savedTimer);
        this.savedTimer = setTimeout(() => { saved.textContent = ''; }, 2500);
      }

      setStatus(message) {
        const status = this.status;
        if (status) status.textContent = message;
      }

      async post(url, body, rerender = true) {
        const payload = { ...body };
        if (rerender) {
          payload.sections = [this.dataset.sectionId];
          payload.sections_url = window.location.pathname;
        }
        if (rerender) this.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (!response.ok) {
            this.setStatus(data.description || data.message || this.dataset.messageError);
            return null;
          }
          if (rerender && data.sections && data.sections[this.dataset.sectionId]) {
            const html = new DOMParser().parseFromString(data.sections[this.dataset.sectionId], 'text/html');
            const fresh = html.querySelector('[data-cart-root]');
            const root = this.querySelector('[data-cart-root]');
            if (fresh && root) root.replaceWith(fresh);
          }
          if (rerender) announceCart('origen-cart', this.dataset.sectionId);
          return data;
        } catch (error) {
          this.setStatus(this.dataset.messageError);
          return null;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('origen-cart', OrigenCart);
  }

  if (!customElements.get('origen-quick-add')) {
    class OrigenQuickAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form || this.initialized) return;
        this.initialized = true;
        this.form.noValidate = true;
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
      }

      async onSubmit(event) {
        event.preventDefault();
        const select = this.form.querySelector('select[name="id"]');
        const status = this.form.querySelector('[role="status"]');
        const button = this.form.querySelector('button[type="submit"]');
        if (select && !select.value) {
          status.textContent = 'Selecciona tu talla.';
          select.focus();
          return;
        }
        button.disabled = true;
        try {
          const response = await fetch(`${routesRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(this.form),
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            status.textContent = data.description || 'Esta talla ya no está disponible. Elige otra talla.';
            return;
          }
          status.textContent = '';
          announceCart('origen-quick-add', this.form.id);
        } catch (error) {
          this.form.submit();
        } finally {
          button.disabled = false;
        }
      }
    }
    customElements.define('origen-quick-add', OrigenQuickAdd);
  }
})();
